import { ReportBase } from 'istanbul-lib-report';
import type { ReportNode } from 'istanbul-lib-report';

export class SummaryToObjectReport extends ReportBase {
    appendToObject: object;

    constructor(opts?: { appendToObject?: object }) {
        super();

        opts ||= {};
        this.appendToObject = opts.appendToObject || {};
    }

    onStart(node: ReportNode) {
        const summary = node.getCoverageSummary(false);
        this.appendToObject = Object.assign(this.appendToObject, summary.toJSON());
    }
}
